import React from 'react'
import Image from 'next/image'
import { styled } from '../../../../stitches.config'
import { Text } from '../../elements/Text/Text'

export interface PostItNoteProps {
    backgroundImage: string
    personImage: string
    postItText: string
    nameText: string
}

const Wrapper = styled('div', {
    position: 'absolute',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '1.5rem',
    height: '18rem',
    width: '17rem',
    transform: 'scale(90%)',
    '@sm': {
        transform: 'scale(95%)',
    },
    '@md': {
        transform: 'none',
    },
})

const BottomBox = styled('div', {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'fit-content',
    paddingBottom: '2rem',
    img: {
        borderRadius: '50%',
        objectFit: 'cover',
    },
})

const PostItNote = ({
    postItText,
    nameText,
    backgroundImage,
    personImage,
}: PostItNoteProps) => {
    return (
        <Wrapper>
            <Image
                src={backgroundImage}
                layout={'fill'}
                style={{
                    zIndex: -1,
                    transform: 'scale(1.1, 1.3)',
                }}
                alt={'Post-it note with message'}
            />
            <Text
                as={'p'}
                css={{
                    textAlign: 'center',
                    padding: '1rem 0',
                    lineHeight: '1.45rem',
                    maxWidth: '85%',
                }}
            >
                {postItText}
            </Text>
            <BottomBox>
                <Image
                    src={personImage}
                    height={35}
                    width={35}
                    alt={'Post-it image'}
                />
                <Text size={2} css={{ paddingLeft: '.5rem' }}>
                    &mdash; {nameText}
                </Text>
            </BottomBox>
        </Wrapper>
    )
}

export default PostItNote
